// extracted by mini-css-extract-plugin
export var container = "Email-module--container--mPXn7";